import { PaperClipIcon } from "@heroicons/react/20/solid";
import jwt_decode from "jwt-decode";
import { useEffect, useState, useRef, useContext } from "react";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";
import { useAxios } from "../api/api";
import {
  HomeIcon,
  PencilSquareIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import i18n from "../i18n/i18n";
import AddAddress from "../components/AddAddress";
import { Context } from "../context/ContextProvider";

export default function Profile({ t }) {
  const navigate = useNavigate();
  const { setCartCount } = useContext(Context);

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingShipping, setIsLoadingShipping] = useState(true);
  const [user, setUser] = useState(null);
  var decoded = jwt_decode(localStorage.getItem("Token"));

  const [open, setOpen] = useState(false);

  const [isSend, setIsSend] = useState(false);

  const oneFetch = useRef(true);
  useEffect(() => {
    if (oneFetch.current) {
      // console.log(
      //   "onFetch: ",
      //   oneFetch.current,
      //   localStorage.getItem("Token") != null
      // );
      oneFetch.current = false;
      // var decoded = jwt_decode(localStorage.getItem("Token"));
      setUser(decoded.user);
      // console.log("user: ", decoded.user);

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
    // else{
    //   navigate('/login')
    //   // oneFetch.current = true;
    // }
  }, []);

  const { response, loading, error } = useAxios({
    method: "GET",
    url: `/users/login/${decoded.user._id}`,
    headers: {
      accept: "*/*",
    },
  });

  return (
    <div className=" bg-white sm:container sm:mx-auto mt-5 mx-5">
      {loading === false && (
        <AddAddress
          open={open}
          setOpen={setOpen}
          isSend={isSend}
          setIsSend={setIsSend}
          i18n={i18n}
          active={true}
          response={response}
        />
      )}
      {isLoading ? (
        <div className="flex items-center justify-center w-full py-20">
          <div className="flex justify-center items-center space-x-1 text-sm text-gray-700">
            <svg
              fill="none"
              className="w-20 h-20 animate-spin"
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                d="M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z"
                fill="currentColor"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div className="overflow-hidden shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                {t("userInformation")}
              </h3>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                {t("userDetails")}
              </p>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
              <dl className="sm:divide-y sm:divide-gray-200">
                <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                  <dt className="text-sm font-medium text-gray-500">
                    {t("username")}
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {user?.displayName}
                  </dd>
                </div>

                <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                  <dt className="text-sm font-medium text-gray-500">
                    {t("email")}
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {user?.email}
                  </dd>
                </div>
                <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                  <dt className="text-sm font-medium text-gray-500">
                    {t("password")}
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    ********
                  </dd>
                </div>
              </dl>
            </div>
          </div>
          {loading === false && response.address.length > 1 && (
            <div className="overflow-hidden shadow sm:rounded-lg mt-5">
              <div className="px-4 py-5 sm:px-6">
                <h3 className="text-base font-semibold leading-6 text-gray-900">
                  {t("shippingInformation")}
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  {t("shippingDetails")}
                </p>
              </div>
              <div className="border-t border-gray-200 px-4 py-5 sm:p-0 ">
                <dl className="sm:divide-y sm:divide-gray-200">
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                    <dt className="text-sm font-medium text-gray-500">
                      {t("displayName")}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {response?.displayName1}
                    </dd>
                  </div>

                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                    <dt className="text-sm font-medium text-gray-500">
                      {t("phone")}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {response?.phone}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                    <dt className="text-sm font-medium text-gray-500">
                      {t("city")}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {response?.city}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                    <dt className="text-sm font-medium text-gray-500">
                      {t("address")}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {response?.address}
                    </dd>
                  </div>

                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                    <dt className="text-sm font-medium text-gray-500">
                      {t("neighborhood")}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {response?.neighborhood}
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                    <dt className="text-sm font-medium text-gray-500">
                      {t("zipCode")}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {response?.zipCode}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          )}
          <button
            type="button"
            className="my-5  inline-flex items-center gap-x-2 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={() => {
              setOpen(true);
              console.log("response: ", response);
            }}
          >
            {response?.address.length > 1 ? (
              <PencilSquareIcon
                className="-ml-0.5 h-5 w-5 ltr:rotate-180"
                aria-hidden="true"
              />
            ) : (
              <PlusIcon
                className="-ml-0.5 h-5 w-5 ltr:rotate-180"
                aria-hidden="true"
              />
            )}

            {response?.address.length > 1 ? t("editAddress") : t("addAddress")}
          </button>
          <button
            type="button"
            className="my-5 mr-4 inline-flex items-center gap-x-2 rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={() => {
              localStorage.removeItem("Token");
              localStorage.removeItem("Order");
              localStorage.setItem("CountCart", 0);
              setCartCount(0);
              navigate("/login", { shallow: true });
            }}
          >
            <ArrowRightOnRectangleIcon
              className="-ml-0.5 h-5 w-5 ltr:rotate-180  "
              aria-hidden="true"
            />
            {t("logout")}
          </button>
        </>
      )}
    </div>
  );
}
